/* global OfficeRuntime */

/**
 * Persistent storage for add-in settings.
 * Prefers OfficeRuntime.storage; falls back to localStorage for dev.
 */
function hasOfficeStorage() {
  return typeof OfficeRuntime !== "undefined" && OfficeRuntime?.storage;
}

export async function getStorageItem(key) {
  if (hasOfficeStorage()) {
    const value = await OfficeRuntime.storage.getItem(key);
    return value ?? null;
  }
  return localStorage.getItem(key);
}

export async function setStorageItem(key, value) {
  if (hasOfficeStorage()) {
    await OfficeRuntime.storage.setItem(key, value);
    return;
  }
  localStorage.setItem(key, value);
}

export async function removeStorageItem(key) {
  if (hasOfficeStorage()) {
    await OfficeRuntime.storage.removeItem(key);
    return;
  }
  localStorage.removeItem(key);
}

/** Copy legacy localStorage values into OfficeRuntime.storage once. */
export async function migrateFromLocalStorage(keys) {
  for (const key of keys) {
    const existing = await getStorageItem(key);
    const legacy = localStorage.getItem(key);
    if (!existing && legacy) {
      await setStorageItem(key, legacy);
    }
  }
}
